import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from "@cinch-labs/design-system";
import { StoryblokRenderer } from "@cinch-nx/landing-ui-shared";
import { storyblokComponents } from "../../data/storyblok-renderer-map";
import styles from "./support-faqs.module.css";
const SupportFaqs = ({ faqs  })=>/*#__PURE__*/ _jsxs("div", {
        className: styles.supportFaqs,
        children: [
            /*#__PURE__*/ _jsx(Text, {
                element: "h2",
                fontSize: "xxl",
                fontWeight: "bold",
                children: "Got a Q? We’ve got the A"
            }),
            /*#__PURE__*/ _jsx(Text, {
                children: "Find everything from how we pick our cars to the different ways you can pay for one."
            }),
            /*#__PURE__*/ _jsx(StoryblokRenderer, {
                block: faqs,
                components: storyblokComponents
            })
        ]
    });
export default SupportFaqs;
